module.exports = __webpack_public_path__ + "assets/restricted_area.d7c673fc.svg";